import ModalDoubleAction from "@/app/components/ui/Modals/DoubleAction";
import TableSkeleton from "@/app/components/ui/Skeletons/TableSkeleton";
import { useIsBookingChargableAPI } from "@/app/hooks/api_hooks/bookings/useIsBookingChargableAPI";
import { useModalState } from "@/app/hooks/ui_hooks/useModalState";
import { useRouter } from "@/app/hooks/useRouter";
import { useState } from "react";
import { BsCurrencyRupee, BsExclamationCircle } from "react-icons/bs";
import { ICancelationModalProps } from "../interface";
export interface IBookingRescheduleModalState {
  userId: string;
  petId: string;
  bookingId: string;
  price?: number;
  isRefunded?: boolean;
}

const RescheduleConfimationModal: React.FC<ICancelationModalProps> = () => {
  /* Instatiations */

  const modalState = useModalState("APPOINTMENT_RESCHEDULE");
  const { execute: fetchBookingStatus, bookingDetails } = useIsBookingChargableAPI();
  const [status, setStatus] = useState<boolean>(false);

  const { getRouteKey } = useRouter();

  /* Instatiations Ends */

  /* Redux States */
  const { bookingId, petId, userId, price } = modalState as IBookingRescheduleModalState;
  /* Redux States Ends */

  const handelReschedule = () => {
    if (status) {
      window.open(
        `${getRouteKey("AVAILABLE_SLOTS", "url")}/${userId}/${petId}?type=reschedule&rbi=${bookingId}`,
        "_self",
      );
    }
  };

  const handleFetchBookingStatus = async () => {
    fetchBookingStatus(bookingId).then(({ status }) => {
      if (status) {
        setStatus(true);
        //
      } else {
        setStatus(false);
      }
    });
  };

  return (
    <ModalDoubleAction
      showIcon={false}
      contentOverflow={true}
      onVisibleCallback={handleFetchBookingStatus}
      modalId="APPOINTMENT_RESCHEDULE"
      button={{
        primaryButtonText: "Yes Reschedule",
        primaryButtonClassname: "bg-[#193A6A] text-white",
        secondaryButtonText: "Go Back",
        primaryCallback: () => {
          handelReschedule();
        },
        shouldHideOnClick: true,
      }}
      content={
        status ? (
          <div>
            <p className="text-sm font-medium text-black">Are you sure you want to Reschedule booking?</p>
            <p className="text-xs pb-3 pt-1 font-bold text-red-600">
              Please Note: No charge for rescheduling within the same day (on VMS only)
            </p>
            {bookingDetails?.is_adjusted && (
              <p className="text-left font-medium text-green-500  text-sm  mt-2 flex items-center gap-1">
                Advance payment already received, no more amount required.
              </p>
            )}

            {bookingDetails?.is_charged && (
              <p className="text-left font-medium text-red-500  text-sm  mt-2 flex items-center gap-1">
                <BsExclamationCircle className="w-4 h-4 text-red-500 text-sm " />
                Late Reschedule fee of <BsCurrencyRupee className="w-4 h-4" />
                {bookingDetails?.amount} will be charged. Rescheduling within 3 hours.
              </p>
            )}
          </div>
        ) : (
          <TableSkeleton />
        )
      }
      title="Reschedule Booking"
      titleIcon="GrAndroid"
      titleIconClassName="text-green-500"
    />
  );
};

export default RescheduleConfimationModal;
